import { render, staticRenderFns } from "./outingHealth.vue?vue&type=template&id=478a6bd4&scoped=true&"
import script from "./outingHealth.vue?vue&type=script&lang=js&"
export * from "./outingHealth.vue?vue&type=script&lang=js&"
import style0 from "./outingHealth.vue?vue&type=style&index=0&id=478a6bd4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478a6bd4",
  null
  
)

export default component.exports